import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, AcDialogService, DIALOG_CONFIG} from 'ac-infra';
import {RoutingServerGroupDialogComponent} from '../routing-server-group-dialog/routing-server-group-dialog.component';
import {NgForm} from '@angular/forms';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';

@AcDialog({
  width: 500,
  height: 560,
  id: 'routingServerMainDialog'
})
@Component({
  selector: 'routing-server-group-main-dialog',
  templateUrl: './routing-server-group-main-dialog.component.html',
  styleUrls: ['./routing-server-group-main-dialog.component.scss']
})
export class RoutingServerGroupMainDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('mapForm') mapForm: NgForm;
  data;
  formNotValid: boolean;
  displayedColumns = ['innerTitle'];
  selectedInnerGroup;
  isUnauthorized: boolean;
  advancedCollapse = true;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private dialogService: AcDialogService,
              private userPrivilege: UserPrivilegeService ) {

    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.data = dialogConfig.dialogData;
    dialogConfig.dialogData.submitButtonDisabled = false;
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }

  ngOnInit(): void {
  }

  addInnerGroup(): void {
    const newInnerGroup = {
      isEdit: false,
      group: this.data.group,
      routingServers: this.data.routingServers,
      selectedInnerGroup: this.data.group.selectedInnerGroup,
      result: {}
    };

    this.dialogService.open(RoutingServerGroupDialogComponent, {
      dialogData: newInnerGroup,
      title: 'Select routing severs',
      onSubmit: () => {
        if (this.selectedInnerGroup) {
          const selectedIndex = this.data.group.groups.findIndex((innerGroup) => {
            return innerGroup.id === this.selectedInnerGroup.id;
          });

          this.data.group.groups.splice(selectedIndex + 1, 0, newInnerGroup.result);
          this.updateInnerGroupsList(this.data.group, []);
          this.fixInnerGroupIds(this.data.group.groups);
        } else {
          this.updateInnerGroupsList(this.data.group, [newInnerGroup.result]);
          this.fixInnerGroupIds(this.data.group.groups);
        }
      }
    });
  }

  updateInnerGroupsList(obj, concatWith): void {
    obj.groups = obj.groups.concat(concatWith);
  }

  fixInnerGroupIds(servers): void {
    for (let i = 0; i < servers.length; i++) {
      servers[i].id = i;
    }
  }

  selectHandler(selected): void {
    this.selectedInnerGroup = selected;
    this.selectedInnerGroup.isFirst = selected.id === 0 ;
    this.selectedInnerGroup.isLast = selected.id === this.data.group.groups.length - 1;
  }

  editInnerGroup(): void {
    const newInnerGroup: any = {
      isEdit: true,
      group: this.data.group,
      routingServers: this.data.routingServers,
      selectedInnerGroup: this.selectedInnerGroup,
      result: {}
    };

    this.dialogService.open(RoutingServerGroupDialogComponent, {
      dialogData: newInnerGroup,
      title: 'Select routing severs',
      onSubmit: () => {
        if (this.selectedInnerGroup && this.selectedInnerGroup !== -1) {

          const selectedIndex = this.data.group.groups.findIndex((innerGroup) => {
            return innerGroup.id === this.selectedInnerGroup.id;
          });

          newInnerGroup.result.id = this.selectedInnerGroup.id;
          this.data.group.groups[selectedIndex] = newInnerGroup.result;
          this.updateInnerGroupsList(this.data.group, []);
          this.selectedInnerGroup = newInnerGroup.result;
        }
        this.selectHandler([this.selectedInnerGroup]);
      },
    });

  }

  removeInnerGroup(): void {
    this.data.group.groups.splice(this.selectedInnerGroup.id, 1);
    this.updateInnerGroupsList(this.data.group, []);
    this.selectedInnerGroup = {id: -1};
    this.fixInnerGroupIds(this.data.group.groups);
  }

  moveUpInnerGroup(): void {
    const selectedIndex = this.data.group.groups.findIndex((innerGroup) => {
      return innerGroup.id === this.selectedInnerGroup.id;
    });

    this.swapInnerGroups(this.data.group, selectedIndex, selectedIndex - 1);
    this.selectHandler(this.selectedInnerGroup);
  }

  moveDownInnerGroup(): void {
    const selectedIndex = this.data.group.groups.findIndex((innerGroup) => {
      return innerGroup.id === this.selectedInnerGroup.id;
    });

    this.swapInnerGroups(this.data.group, selectedIndex, selectedIndex + 1);
    this.selectHandler(this.selectedInnerGroup);
  }

  swapInnerGroups(selected, from, to): void {
    const tempItem = selected.groups[to];
    this.selectedInnerGroup.id = to;
    selected.groups[to] = this.selectedInnerGroup;
    selected.groups[from] = tempItem;
    selected.groups[to].id = to;
    selected.groups[from].id = from;
    this.updateInnerGroupsList(selected, []);
  }
}
